// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__b7ps3","list":"PatternAutocomplete_list__1736v"};